module.exports = __webpack_public_path__ + "930bbbf901d3fb633550d34a96c67552.png";